export const STORAGE_PREFIX = 'ccdc_v2.0_';
